import {BackendApi} from "../../api/api.ts";

export class UserBusinessFlagsService {
    constructor(
        private readonly flags: Record<string, boolean>,
        private readonly api: BackendApi
    ) {
    }''

    public getFlag(key: string): boolean {
        if (!this.flags.hasOwnProperty(key))
            return false
        return this.flags[key]
    }

    public async setFlag(key: string, value: boolean) {
        await this.api.post('me/update-flag', {
            flag_name: key,
            flag_value: value
        })

        this.flags[key] = value
    }
}
